import {Component, input} from '@angular/core';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {Button} from 'primeng/button';

@Component({
  selector: 'ng-confirm-dialog',
  imports: [
    Button
  ],
  template: `
    <div style="margin-bottom: 20px; display: flex; gap: 20px">
      <div style="font-size: 2rem;color:var(--p-button-primary-background)">
        <i class="fa-regular fa-circle-question"></i>
      </div>
      <div>
        {{ message() }}
      </div>
    </div>
    <div style="display: flex; gap: 1rem;justify-content: flex-end;">
      <p-button label="OK" (onClick)="confirm()"></p-button>
      <p-button severity="secondary" label="Cancel" (onClick)="cancel()"></p-button>
    </div>
  `
})
export class ConfirmDialog {
  public message = input("")

  constructor(private ref: DynamicDialogRef,) {
  }

  cancel() {
    this.ref.close(false);
  }

  confirm() {
    this.ref.close(true);
  }
}
